export default function BackgroundEffects() {
  return (
    <div className="hidden md:block">
      {/* Subtle grid pattern */}
      <div className="grid-overlay" />
      
      {/* Corner glow accents */}
      <div className="corner-accent top-left" />
      <div className="corner-accent bottom-right" />
      
      {/* Animated sparks and embers */}
      <div className="sparks-bg">
        {/* Sparks */}
        <div className="spark" />
        <div className="spark" />
        <div className="spark" />
        <div className="spark" />
        <div className="spark" />
        <div className="spark" />
        <div className="spark" />
        <div className="spark" />
        {/* Embers */}
        <div className="ember" />
        <div className="ember" />
        <div className="ember" />
        <div className="ember" />
        {/* Extra sparks */}
        <div className="spark" />
        <div className="spark" />
        <div className="spark" />
        <div className="spark" />
        {/* Extra embers */}
        <div className="ember" />
        <div className="ember" />
      </div>
    </div>
  );
}
